
import { useEffect } from "react";
import { useState } from "react";
import { SubscribeEmail } from "../../Store/Api/ApiCall";
import {
  Block,
  Button,
  Card_img,
  Center,
  DescriptionText,
  Dynamic_Margin,
  Fixed_padding,
  Flex_Con,
  Floating_Div,
  GuideText,
  HeaderText,
  HeaderTextLighter,
  InputField,
  Padding,
  Padding100,
} from "../../component/styledComponent";
import Fonts from "../../Customs/Fonts";
import Size from "../../Customs/Size";
import Resource from "../../Resources/Resource";
import EmailForm from "./EmailForm";
import { FooterSection, EndingFooter, SubmitUX, Footer } from "./Footer";

const Home = () => {
  return (
    <>
      <Block style={{ backgroundColor: "#0E0E20" }}>
        <Block>
          <Flex_Con height="100vh" MFlexW="wrap-reverse">
            <Block
              display="flex"
              width="70%"
              pad="0 100px"
              alignI="Center"
              style={{ maxWidth: "400px", zIndex: "1" }}
              Mpadd="0"
            >
              <Description ></Description>
            </Block>

            <Block display="flex" alignI="Center" minW="30%">
              <Card_Design></Card_Design>
            </Block>
          </Flex_Con>
        </Block>
        <EmailForm></EmailForm>
        {FooterSection()}
        {Footer()}
        {EndingFooter()}
      </Block>
    </>
  );
};

const Description = () => {
  return (
    <>
      <Block>
        <Dynamic_Margin >
          {Introducing_Text()}
          {Description_Text()}
        </Dynamic_Margin>
      </Block>
    </>
  );
};
const Introducing_Text = () => {
  return (
    <>
      <HeaderTextLighter size={Size.homePage.Intro} style={{fontWeight:"700"}}>
        Introducing
      </HeaderTextLighter>
      <HeaderText size={Size.homePage.xpass} style={{fontWeight:"700"}}>X-PASS</HeaderText>
    </>
  );
};
const Description_Text = () => {
  return (
    <>
      <DescriptionText>
        The x-pass concept aims to revolutionize NFT-Tickets and Web3-Events by
        incorporating cutting-edge technology, passes will be unique,
        verifiable, and individually owned. Additionally, the owners of x-pass
        NFTs will have the opportunity to claim rewards associated with their
        pass.
      </DescriptionText>
    </>
  );
};

const Card_Design = () => {
  return (
    <>
      <Block pad="5px">
        <Block
          style={{
            position: "absolute",
            top: "-100px",
            overflow: "visible",
          }}
        >
          <Card_img
            src={Resource.BgBlend.Mix}
            style={{ overflow: "visible", height: "1000px" }}
          />
        </Block>
        <Block style={{ position: "relative", width: "96%" }}>
          <Floating_Div>
            <Card_img src={Resource.Card.Location}></Card_img>
          </Floating_Div>
        </Block>
      </Block>
    </>
  );
};

export default Home;
